<template>
  <div>
    <editor-menu-bar :editor="editor">
      <div slot-scope="{ commands, isActive }" class="mb-2 mt-2 flex justify-content-between">
        <span>
          <span class="pointer" :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
            <i class="fa fa-bold p-2 menubar-icon" />
          </span>

          <span class="pointer" :class="{ 'is-active': isActive.italic() }" @click="commands.italic">
            <i class="fa fa-italic p-2 menubar-icon" />
          </span>

          <span class="pointer" :class="{ 'is-active': isActive.underline() }" @click="commands.underline">
            <i class="fa fa-underline p-2 menubar-icon" />
          </span>


          <span class="p-2">
            <span class="pointer dropdown-toggle variables" id="alignButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-align-left p-2" />
            </span>
            <div class="dropdown-menu" id="dropdownAlign" aria-labelledby="alignButton">
              <a class="dropdown-item" @click.prevent="commands.paragraph({ textAlign: 'left' })" href="#"><i class="fa fa-align-left p-2" /></a>
              <a class="dropdown-item" @click.prevent="commands.paragraph({ textAlign: 'center' })" href="#"><i class="fa fa-align-center p-2" /></a>
              <a class="dropdown-item" @click.prevent="commands.paragraph({ textAlign: 'right' })" href="#"> <i class="fa fa-align-right p-2" /></a>
            </div>
          </span>

          <span class="pointer" @click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })">
            <i class="fa fa-table p-2 menubar-icon" />
          </span>

          <span v-if="isActive.table()" class="p-2">
            <span class="pointer dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-pencil-square-o" />
            </span>
            <div class="dropdown-menu tabledrp" aria-labelledby="headingButtonn">
              <a class="dropdown-item" @click="commands.addColumnBefore">Add column left</a>
              <a class="dropdown-item" @click="commands.addColumnAfter">Add column right</a>
              <a class="dropdown-item" @click="commands.addRowAfter">Add row below</a>
              <a class="dropdown-item" @click="commands.addRowBefore">Add row above</a>
              <div class="dropdown-divider" />
              <a class="dropdown-item" @click="commands.toggleCellMerge">Merge cells</a>
              <div class="dropdown-divider" />
              <a class="dropdown-item" @click="commands.deleteRow">Delete row</a>
              <a class="dropdown-item" @click="commands.deleteColumn">Delete column</a>
              <a class="dropdown-item" @click="commands.deleteTable">Delete table</a>
            </div>
          </span>
          <span class="pointer" @click="showImagePrompt(commands.image)">
            <i class="fa fa-image p-2 menubar-icon" />
          </span>

          <span class="pr-2">
            <span class="pointer dropdown-toggle variables" id="headingButton" data-toggle="dropdown">
              <i class="fa fa-header p-2" />
            </span>
            <div class="dropdown-menu" aria-labelledby="headingButtonn">
              <a class="dropdown-item" @click.prevent="commands.heading({ level: 1 })">Heading</a>
              <a class="dropdown-item" @click.prevent="commands.heading({ level: 3 })">Subheading</a>
              <a class="dropdown-item" @click.prevent="commands.paragraph">Paragraph</a>
            </div>
          </span>

          <span class="pr-2">
            <span class="pointer dropdown-toggle variables" id="warningButtons" data-toggle="dropdown">
              <i class="fa fa-exclamation-triangle p-2" />
            </span>
            <div class="dropdown-menu" aria-labelledby="warningButtons">
              <a
                class="dropdown-item"
                @click="commands.warningInput({class: 'alert-primary', inputClass: 'info-input'})"
              >
                Info
              </a>
              <a
                class="dropdown-item"
                @click="commands.warningInput({class: 'alert-warning', inputClass: 'disclaimer-input'})"
              >
                Disclaimer
              </a>
              <a
                class="dropdown-item"
                @click="commands.warningInput({class: 'alert-danger', inputClass: 'warning-input'})"
              >
                Warning
              </a>
            </div>
          </span>

          <span class="pr-2">
            <span class="pointer dropdown-toggle variables" id="inputButton" data-toggle="dropdown">
              Input
            </span>
            <div class="dropdown-menu" aria-labelledby="inputButtonn">
              <a class="dropdown-item" @click.prevent="commands.todo_list">Checkbox</a>
              <a class="dropdown-item" @click.prevent="commands.inputs()">Single field</a>
              <!-- <a class="dropdown-item" @click.prevent="commands.textarea()">Textarea</a> -->
            </div>
          </span>


          <span class="p-2">
            <span class="pointer dropdown-toggle variables" id="variableButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Variables
            </span>
            <div class="dropdown-menu" id="dropdownVariable" aria-labelledby="variableButton">
              <VueFuse
                placeholder="Search for variable"
                @fuseResultsUpdated="search"
                :keys="['name']"
                :list="variablesArray"
                class="dropdown-item"
              />
              <a
                v-for="(variable, index) in vars"
                :key="variable.name"
                class="dropdown-item variables-font" href="#"
                @click.prevent="commands.mention({id: index, label: variable.name})"
              >
                {{ variable.name }}
              </a>
            </div>
          </span>
          <span class="pointer" @click="commands.undo">
            <i class="fa fa-undo p-2 menubar-icon" />
          </span>
          <span class="pointer" @click="commands.redo">
            <i class="fa fa-repeat p-2 menubar-icon" />
          </span>
        </span>
        <span class="flex">
          <span class="pointer pr-2" style="order: 1" data-toggle="dropdown">
            <i class="fa fa-eye p-2" />
          </span>
          <div class="dropdown-menu p-3" aria-labelledby="showComponentButton">
            <form>
              <span class="font-weight-bold">Show component to</span>
              <div class="switchToggle flex justify-content-between pb-2 pt-4">
                <span>Customer</span>
                <input type="checkbox" :id="'customer' + componentId" value="true" v-model="component.customer_display" />
                <label :for="'customer' + componentId">Toggle</label>
              </div>
              <div class="switchToggle flex justify-content-between">
                <span>Foreman</span>
                <input type="checkbox" :id="'foreman' + componentId" value="true" v-model="component.mover_display" />
                <label :for="'foreman' + componentId">Toggle</label>
              </div>
            </form>
          </div>
          <i class="fa fa-trash p-2 pointer" style="order: 2" @click="$emit('deleted')" />
        </span>
      </div>
    </editor-menu-bar>
    <editor-content class="editor-styling" :editor="editor" />
  </div>
</template>

<script>
import Fuse from 'fuse.js';
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Bold,
  Italic,
  Underline,
  Heading,
  Image,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  History,
  Mention,
  TrailingNode,
  TodoList,
} from 'tiptap-extensions';
import WarningInput from '../../includes/warning';
import Elements from '../../includes/elements';
import Paragraph from '../../includes/paragraph';
import Inputs from '../../includes/inputs';
import Labels from '../../includes/labels';
import TodoItem from '../../includes/TodoItem';
import Textarea from '../../includes/textArea';

export default {
  components: {
    EditorMenuBar,
    EditorContent,
  },
  props: {
    variablesKeys: {
      type: Array,
      default: () => [],
    },
    variablesArray: {
      type: Array,
      default: () => [],
    },
    component: {
      type: Object,
      default: () => {},
    },
    componentId: {
      type: Number,
      default: null,
    },
    contractUpdated: {
      type: String,
      default: null,
    },
    sectionId: {
      type: Number,
      default: null,
    },
    sect: {
      type: Array,
      default: () => [],
    },
    drag: {
      type: Boolean,
      default: false,
    },
    dragging: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor: new Editor({
        editable: true,
        extensions: [
          new Table({
            resizable: true,
          }),
          new TableHeader(),
          new TableCell(),
          new TableRow(),
          new Bold(),
          new Italic(),
          new Underline(),
          new Image(),
          new Heading({ levels: [1, 2, 3, 4, 5, 6] }),
          new History(),
          new TrailingNode(),
          new WarningInput({ panel: this.panel }),
          new Elements({ type: this.elementType }),
          new TodoItem({
            nested: true,
          }),
          new TodoList(),
          new Inputs(),
          new Textarea(),
          new Paragraph(),
          new Labels(),
          new Mention({
            matcher: {
              char: '',
            },

            items: () => [...this.variables],
            // is called when a suggestion starts
            onEnter: ({ items, query, range, command, virtualNode }) => {
              this.query = query;
              this.filteredUsers = items;
              this.suggestionRange = range;
              this.renderPopup(virtualNode);
              // we save the command for inserting a selected mention
              // this allows us to call it inside of our custom popup
              // via keyboard navigation and on click
              this.insertMention = command;
            },
            // is called when a suggestion has changed
            onChange: ({ items, query, range, virtualNode }) => {
              this.query = query;
              this.filteredUsers = items;
              this.suggestionRange = range;
              this.navigatedUserIndex = 0;
              this.renderPopup(virtualNode);
            },
            // is called when a suggestion is cancelled
            onExit: () => {
              // reset all saved values
              this.query = null;
              this.filteredUsers = [];
              this.suggestionRange = null;
              this.navigatedUserIndex = 0;
              this.destroyPopup();
            },
            // is called on every keyDown event while a suggestion is active
            onKeyDown: ({ event }) => {
              // pressing up arrow
              if (event.keyCode === 38) {
                this.upHandler();
                return true;
              }
              // pressing down arrow
              if (event.keyCode === 40) {
                this.downHandler();
                return true;
              }
              // pressing enter
              if (event.keyCode === 13) {
                this.enterHandler();
                return true;
              }

              return false;
            },
            onFilter: (items, query) => {
              if (!query) {
                return items;
              }

              const fuse = new Fuse(items, {
                threshold: 0.2,
                keys: ['name'],
              });

              return fuse.search(query);
            },
          }),
        ],
        onUpdate: ({ getHTML }) => {
          this.html = getHTML();
          this.$emit('update', this.html, this.sectionId, this.componentId);
        },
      }),
      query: null,
      suggestionRange: null,
      filteredUsers: [],
      navigatedUserIndex: 0,
      insertMention: () => {},
      observer: null,
      command: null,
      panel: null,
      elementType: null,
      html: '',
      editable: false,
      vars: [],
    };
  },
  watch: {
    drag() {
      this.editor.setOptions({
        editable: !this.drag,
      });
    },
    dragging() {
      this.editor.setOptions({
        editable: !this.editable,
      });
    },
    contractUpdated() {
      this.storeHtmlToObject();
    },
  },
  created() {
    this.storeHtmlToObject();
    this.search();
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    search(value) {
      this.vars = value;
    },
    showImagePrompt(command) {
      const src = prompt('Enter the url of your image here');
      if (src !== null) {
        command({ src });
      }
    },
    storeHtmlToObject() {
      this.sect.forEach(section => {
        if (section.uid === this.sectionId)
          section.components.forEach(component => {
            if (component.uid === this.componentId) {
              this.editor.setContent(component.html);
            }
          });
      });
    },
  },
};
</script>
<style lang="scss">
ul[data-type='todo_list'] {
  padding-left: 0;
}
li[data-type='todo_item'] {
  display: flex;
  flex-direction: row;
}
.todo-checkbox {
  border: 2px solid #2962ff;
  height: 0.9em;
  width: 0.9em;
  box-sizing: border-box;
  margin-right: 10px;
  margin-top: 0.3rem;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
  border-radius: 0.2em;
  background-color: transparent;
  transition: 0.4s background;
}
.todo-content {
  flex: 1;
  > p:last-of-type {
    margin-bottom: 0;
  }
  > ul[data-type='todo_list'] {
    margin: 0.5rem 0;
  }
}
li[data-done='true'] {
  > .todo-checkbox {
    background-color: #2962ff;
  }
}
li[data-done='false'] {
  text-decoration: none;
}
.dropdown-menu.tabledrp {
  max-height: 500px;
}
.ProseMirror {
  word-break: break-word;
}
.ProseMirror img {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.editor-styling {
  max-height: 460px;
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/TextEditor.vue